import Vue from 'vue'
import VTextFieldWithValidation from '../components/inputs/VTextFieldWithValidation'
import VSelectWithValidation from '../components/inputs/VSelectWithValidation'
import {
  extend,
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate'
import {
  email,
  max,
  min,
  numeric,
  required,
  regex,
} from 'vee-validate/dist/rules'

extend('email', {
  ...email,
  message: 'Este campo deve conter um email válido',
})
extend('max', max)
extend('min', {
  ...min,
  message: field => 'O campo deve conter um nome válido',
})
extend('numeric', numeric)
extend('required', {
  ...required,
  message: field => 'O campo ' + field + ' é obrigatório',
})
extend('regex', {
  ...regex,
  message: field => 'O campo deve conter um ' + field + ' válido.',
})

Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)
Vue.component('tex-field-with-validation', VTextFieldWithValidation)
Vue.component('select-with-validation', VSelectWithValidation)
